module.exports = __webpack_public_path__ + "fonts/PPRightGrotesk-CompactBlack.b6a83a0.woff2";